import { render, staticRenderFns } from "./PoloEdit.vue?vue&type=template&id=708f67ac&scoped=true&"
import script from "./PoloEdit.vue?vue&type=script&lang=js&"
export * from "./PoloEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708f67ac",
  null
  
)

export default component.exports